// @flow
import React from "react";
import {Context} from "react";
import {RootStore} from "./stores";

const RootContext: Context<RootStore> = React.createContext<RootStore>({});
export default RootContext;
